import { render, staticRenderFns } from "./I2FormVueSelect.vue?vue&type=template&id=f1d0c84e&"
import script from "./I2FormVueSelect.vue?vue&type=script&lang=js&"
export * from "./I2FormVueSelect.vue?vue&type=script&lang=js&"
import style0 from "./I2FormVueSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports